import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountries,
  getStatus,
  getUserCountry,
  getMessage,
  submitSubscribeForm,
} from "../../features/subscribe/subscribeSlice";
import ErrorMessage from "./ErrorMessage";
import InputText from "./InputText.component";
import Select from "./Select.component";
import SubmitBtn from "./SubmitBtn";
import SuccessSubscribe from "./SuccessSubscribe";
import Waiting from "./Waiting";

const FormFields = () => {
  const countries = useSelector(getCountries);
  const userCountry = useSelector(getUserCountry);
  const message = useSelector(getMessage);
  const status = useSelector(getStatus);

  const dispatch = useDispatch();
  const [values, setValues] = useState({
    apiKey: "fQGd1bA1iMjiiU2C5kUZ",
    list: "P5siQMT7VwlzLSF5Pul50w",
    silent: true,
    name: "",
    email: "",
    country: "",
    boolean: true,
  });
  const { name, email, country } = values;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    if (!email) return;

    var bodyFormData = new FormData();
    Object.entries(values).map((value, key) => {
      bodyFormData.append(value[0], value[1]);
      return value;
    });
    dispatch(submitSubscribeForm(bodyFormData));
  };
  useEffect(() => {
    setValues({ ...values, country: userCountry });
    // eslint-disable-next-line
  }, [userCountry]);
  useEffect(() => {
    if (message === "") {
      setValues({
        apiKey: "fQGd1bA1iMjiiU2C5kUZ",
        list: "P5siQMT7VwlzLSF5Pul50w",
        silent: true,
        name: "",
        email: "",
        country: userCountry,
        boolean: true,
      });
    }
    // eslint-disable-next-line
  }, [message]);

  if (status === "success") {
    return <SuccessSubscribe />;
  }

  return (
    <div className="pt-2 relative">
      {status === "error" && <ErrorMessage message={message} />}
      <form onSubmit={onSubmitForm}>
        <InputText
          id="name"
          type="text"
          label="Full name"
          value={name}
          onChange={handleChange}
        />
        <InputText
          id="email"
          type="email"
          label="Email"
          value={email}
          onChange={handleChange}
          required={true}
        />
        <Select
          id="email"
          onChange={handleChange}
          value={country}
          countries={countries}
        />

        <SubmitBtn />
      </form>
      {status === "onSubmit" && <Waiting />}
    </div>
  );
};

export default FormFields;
